const PRD_FALLBACK = {
  apiKey: "AIzaSyAeuYWitJKANqEm4if-5XtykxXiROsERjY",
  authDomain: "due-prd.firebaseapp.com",
  projectId: "due-prd",
  storageBucket: "due-prd.appspot.com",
  messagingSenderId: "1002225243527",
  appId: "1:1002225243527:web:77272c01a6d1fbcc3f2f22",
  measurementId: "G-G4S1L4KJKZ",
};

const pick = (value, fallback) => {
  const normalized = (value || "").toString().trim();
  return normalized.length > 0 ? normalized : fallback;
};

export const firebaseConfig = {
  apiKey: pick(process.env.VUE_APP_FIREBASE_API_KEY, PRD_FALLBACK.apiKey),
  authDomain: pick(process.env.VUE_APP_FIREBASE_AUTH_DOMAIN, PRD_FALLBACK.authDomain),
  projectId: pick(process.env.VUE_APP_FIREBASE_PROJECT_ID, PRD_FALLBACK.projectId),
  storageBucket: pick(process.env.VUE_APP_FIREBASE_STORAGE_BUCKET, PRD_FALLBACK.storageBucket),
  messagingSenderId: pick(process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID, PRD_FALLBACK.messagingSenderId),
  appId: pick(process.env.VUE_APP_FIREBASE_APP_ID, PRD_FALLBACK.appId),
  measurementId: pick(process.env.VUE_APP_FIREBASE_MEASUREMENT_ID, PRD_FALLBACK.measurementId),
};
